<!--
 * @Author: hfxie
 * @Date: 2021-01-01 17:10:10
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-06-21 09:49:11
 * @Description: 主组件入口
-->

<template>
  <div
    class="component-box"
    :data-page-id="uuid"
    :id="uuid"
  >
    <CqLoading v-if="$store.state.dataLoadingStatus === true" />
    <Root v-else />

  </div>
</template>

<script>
import CqLoading from "./components/CqLoading/CqLoading.vue";
import Root from "./components/Root/Root";
export default {
  name: "App",
  data() {
    return {

    };
  },
  methods: {

  },
  components: {
    CqLoading,
    Root,

  },
  computed: {
    uuid() {
      return this.$store.state.uuid;
    },
  },
  mounted() {
    console.log("mmc-projectTree", Date.now());
  },
  updated() {
    console.log("mmc-projectTree", Date.now());
  },
};
</script>

<style lang="less" scoped>
.component-box {
  color: @textColor;
  background-color: #ffffff;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0;
  user-select: none;
  font-family: "Microsoft YaHei", PingFangSC-Regular, "Helvetica Neue",
    Helvetica, Arial, "Hiragino Sans GB", "WenQuanYi Micro Hei", sans-serif;
  .hide {
    display: none !important;
  }
  .box-content {
    border: 1px dashed #e1453e;
    margin-bottom: 20px;
  }
}
</style>
